import React from 'react';
// Conta de `segundos` até zero, um por segundo, e chama `onFim` uma única vez. Para quando `ativa` vira false.
export var useContagemRegressiva = function (segundos, ativa, onFim) {
    var _a = React.useState(segundos), restante = _a[0], setRestante = _a[1];
    var onFimRef = React.useRef(onFim);
    onFimRef.current = onFim;
    React.useEffect(function () {
        if (!ativa)
            return undefined;
        var intervalo = window.setInterval(function () {
            setRestante(function (atual) { return Math.max(atual - 1, 0); });
        }, 1000);
        return function () { return window.clearInterval(intervalo); };
    }, [ativa]);
    React.useEffect(function () {
        if (ativa && restante === 0)
            onFimRef.current();
    }, [ativa, restante]);
    return restante;
};
